<template>
  <div class="yk-homework">
    <div class="yk-comeback-s-new clearfix">
      <div class="yk-ap-que-name">
        <el-input
          class="input-with-select"
          v-model="praname"
          title="回车完成编辑"
          v-if="isShowInput"
          @blur="hideTitleInput"
          @keyup.enter.native="hideTitleInput"/>
        <div v-else>
          <label>{{praname}}</label>
          <i class="el-icon-edit" @click="showTitleInput" title="点击编辑标题"/>
        </div>
      </div>
      <div class="yk-home-work-score">总分：{{totalscore}}</div>
      <el-button
        type="primary"
        @click="backone"
        icon="wl-icon-fanhui2"
        class="gobackBtn-brainStorm"
      ></el-button>
       <el-button
        type="primary"
        class="hander-paper"
        size="small"
        @click="showAutoPaper"
      >自动出卷</el-button>
    </div>
    <el-dialog
      type="text"
      :title="slected"
      width="80%"
      height="100%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible">
      <questionList
        :courseId="courseId"
        :isclear="isclear"
        :checkedIds.sync="checkedIds"
        :checkTotalScore.sync="checkTotalScore"
        :exitIds="exitIds"
        :IsTest="IsTest"
      ></questionList>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onDialogCancle">取消</el-button>
        <el-button type="primary" @click="onDialogSure">确定</el-button>
      </div>
    </el-dialog>
    <!-- 批量打分弹框 -->
    <el-dialog
      title="题目分值批量设置"
      width="550px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="setScodeVisible"
      :before-close="handleClose"
    >
      <div class="yk-set-question-batch-score-main">
        <div class="set-score-head">
          <span class="sp-total-score">总分:</span>
          <span>{{wholeSocre}}分</span>
        </div>
        <div
          v-for="(item,index) in setBatchQuestionData"
          :key="index"
          class="set-score-list-li clearfix">
          <span class="sp-question-name">{{item.name}}:</span>
          <el-input-number
            :max="100"
            :min="0"
            type="number"
            size="mini"
            style="width:120px;"
            v-model="item.value"
          ></el-input-number>
          <span class="sp-all-score-1">分/题</span>
          <div class="total-score-con">
            <span>共{{item.totalNum}}题总分:</span>
            <span class="sp-all-score">{{item.totalScore}}分</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSetScore">取消</el-button>
        <el-button type="primary" @click="sureSetScore">确定</el-button>
      </div>
    </el-dialog>

    <div class="yk-batch-set-score-con" v-if="questionList.length > 0">
      <el-button
        type="primary"
        size="small"
        icon="wl-icon-danmushu"
        @click="setBatchQuestionScore"
        v-if="questionList.length != 0"
      >批量设分</el-button>
    </div>
    <div class="yk-s-workset">
      <ul>
        <li class="clearfix">
          <i class="el-icon-setting fll">作业设置</i>
        </li>
        <li class="clearfix" @change="saveRule">
          <span class="yk-setTitle">&emsp;答案公布设置</span>
          <el-radio v-model="AnswerPublishRule" :label="1">截止后公布答案</el-radio>
          <el-radio v-model="AnswerPublishRule" :label="2">作答后公布答案</el-radio>
          <el-radio v-model="AnswerPublishRule" :label="0">不公布</el-radio>
        </li>
        <li class="clearfix" @change="saveRule">
          <span class="yk-setTitle">&emsp;成绩公布设置</span>
          <el-radio v-model="ScorePublichRule" :label="1">截止后公布成绩</el-radio>
          <el-radio v-model="ScorePublichRule" :label="2">作答后公布成绩</el-radio>
          <el-radio v-model="ScorePublichRule" :label="0">不公布</el-radio>
        </li>
        <li class="clearfix" @change="saveRule">
          <span class="yk-setTitle">&emsp;多选题记分设置</span>
          <el-radio v-model="MultiselectRule" :label="0">多选、少选、错选不得分</el-radio>
          <el-radio v-model="MultiselectRule" :label="1">少选时按选项个数计分</el-radio>
          <el-radio v-model="MultiselectRule" :label="2">少选时得一半分</el-radio>
        </li>
        <li class="clearfix" v-if="!IsTest" @change="saveRule">
          <span class="yk-setTitle">&emsp;填空题记分设置</span>
          <el-radio v-model="FillRule" :label="0">答案不匹配时手动批改</el-radio>
          <el-radio v-model="FillRule" :label="1">答案不匹配时自动0分</el-radio>
        </li>
        <li class="clearfix" @change="saveRule">
          <span class="yk-setTitle">&emsp;是否题目乱序</span>
          <el-radio v-model="quesSortRule" :label="1">是</el-radio>
          <el-radio v-model="quesSortRule" :label="0">否</el-radio>
        </li>
        <li class="clearfix" @change="saveRule">
          <span class="yk-setTitle">&emsp;是否选项乱序</span>
          <el-radio v-model="seleteSortRule" :label="1">是</el-radio>
          <el-radio v-model="seleteSortRule" :label="0">否</el-radio>
        </li>
      </ul>
      <br>
    </div>
    <div class="get-quetion-list-wrapper" @click="dialogVisible=true">
      <i class="wl-icon-tianjia1"></i>
      <span>从题库中选题</span>
    </div>
    <div class="yk-s-homework-questions" v-for="(item,index) in questionList" :key="index">
      <ul class="yk-hw-question">
        <li :id="index">
          <div class="yk-question-container">
            <header>
              <span class="yk-sequence">{{index+1}}</span>
              <span>{{getQuestionType(item.QuestionType)}}</span>
              <span class="yk-diffcult" disabled :max="3">难度：{{changedif(item.Difficulty)}}</span>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                class="flr delete"
                @click="setDeleteId(item)"
              >删除</el-button>
              <el-dialog
                type="text"
                title="删除题目"
                width="30%"
                :visible.sync="del"
                :append-to-body="true"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
              >
                <div>{{tisi}}</div>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="cancleDelete()">取消</el-button>
                  <el-button type="primary" @click="delQuestionInfoById(index)">确定</el-button>
                </div>
              </el-dialog>
              <div class="flr">
                <div
                  style="display: inline-block;box-sizing: border-box;vertical-align: -2px;margin-right: 8px;"
                >
                  <label for>分值：</label>
                  <el-input
                    v-model="item.Score"
                    min="0"
                    max="100"
                    type="number"
                    style="width:80px;"
                    @blur="blurQuestion(item.Id,item.Score,item.QuestionType,item.sublist.length)"
                  ></el-input>
                </div>
                <el-button
                  type="primary"
                  icon="wl-icon-shangyi"
                  size="mini"
                  @click="moveUp(index)"
                  v-if="index !=0"
                >上移</el-button>
                <el-button
                  type="primary"
                  icon="wl-icon-xiayi"
                  size="mini"
                  @click="moveDown(index)"
                  v-if="index < questionList.length-1"
                >下移</el-button>
              </div>
            </header>
            <Multiselect
              :IsTitle="false"
              :IsSelects="false"
              :IsAnswers="true"
              :IsAnalysis="-1"
              v-if="item.QuestionType==1 || item.QuestionType==2"
              :data.sync="item"
            />
            <true-false
              :IsTitle="false"
              :IsSelects="-1"
              :IsAnswers="true"
              :IsAnalysis="-1"
              v-else-if="item.QuestionType==3"
              :data.sync="item"
            />
            <fillInTheBlanks
              :IsTitle="false"
              :IsSelects="-1"
              :IsAnswers="true"
              :IsAnalysis="-1"
              v-else-if="item.QuestionType==4"
              :data.sync="item"
            />
            <short-answer
              :IsTitle="false"
              :IsSelects="false"
              :IsAnswers="-1"
              :IsAnalysis="-1"
              v-else-if="item.QuestionType==5"
              :data.sync="item"
            />
            <synthesis
              :IsSelects="-1"
              :childQuestionList="item.sublist"
              :IsList="true"
              :IsTitle="false"
              v-else-if="item.QuestionType ==6"
              :data.sync="item"
            />
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      title="随机出题"
      :append-to-body="true"
      :visible.sync="suijidialogVisible"
      width="1000px"
      :before-close="suijihandleClose"
      :close-on-click-modal="false">
      <el-tabs v-model="randomType" type="card" @tab-click="randomTypeChange">
        <el-tab-pane label="题型出题" name="1">
          <div class="yk-random-tab">
            <el-form label-width="80px">
              <el-form-item label="难度：">
                <el-checkbox-group v-model="difficultys" @change="setQuesNumber">
                  <el-checkbox label="1">简单</el-checkbox>
                  <el-checkbox label="2">一般</el-checkbox>
                  <el-checkbox label="3">困难</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
               <div class="yk-text-count">总分：{{suijitotalscore}}分</div>
              <el-form-item label="知识点：">
                <el-select v-model="Knowledges" multiple placeholder="请选择" @change="setQuesNumber">
                  <el-option
                    v-for="item in knowledgeLists"
                    :key="item.Id"
                    :label="item.KnowledgeName"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <ul>
              <li class="clearfix" v-for="(item,index) in randomQuesData" :key="index">
                <div class="yk-setTitle-text">
                  <span class="yk-setTitle">&emsp;{{type[item.QestionType]}}</span>
                </div>
                <span>题目数量：</span>
                <el-input-number class="topicRulechoose" v-model="item.QuestionCount" size="mini" controls-position="right" :max="item.QuestionAllCount" :min="0" @change="setRandomQuesScore(index)"></el-input-number>
                <span class="yk-setScore"> / {{item.QuestionAllCount}}</span>
                <span>每题分值：</span>
                <el-input-number class="topicRulechoose" v-model="item.QuestionScore" size="mini" controls-position="right" :max="100" :min="0"  @change="setRandomQuesScore(index)"></el-input-number>
                <span style="margin-left: 60px;">总分：</span>
                <el-input-number class="topicRulechoose" v-model="item.AllScore" size="mini" controls-position="right" disabled></el-input-number>

              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="知识点出题" name="2">
          <div class="yk-random-tab">
            <el-form label-width="80px">
              <el-form-item label="难度">
                <el-checkbox-group v-model="difficultys" @change="setSuiJiQuesNumber">
                  <el-checkbox label="1">简单</el-checkbox>
                  <el-checkbox label="2">一般</el-checkbox>
                  <el-checkbox label="3">困难</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
            <div class="yk-text-count">总分：{{suijitotalscore}}分</div>
            <ul>
              <li class="clearfix" v-for="(item,index) in randomQuesData" :key="index">
                <div class="yk-number-text">
                  <div class="yk-setTitle-text" :title="item.KnowledgeName">
                    <span class="yk-setTitle">&emsp;{{item.KnowledgeName}}</span>
                  </div>  
                    <span>题目数量：</span>
                  <el-input-number class="topicRulechoose" v-model="item.QuestionCount" size="mini" controls-position="right" :max="item.QuestionAllCount" :min="0" @change="setRandomQuesScore(index)"></el-input-number>
                  <span class="yk-setScore"> / {{item.QuestionAllCount}}</span>
                </div>
                <div class="yk-number-text">
                  <span>每题分值：</span>
                  <el-input-number class="topicRulechoose" v-model="item.QuestionScore" size="mini" controls-position="right" :max="100" :min="0"  @change="setRandomQuesScore(index)"></el-input-number>
                </div>
                <div class="yk-number-text">
                  <span style="margin-left: 60px;">总分：</span>
                  <el-input-number class="topicRulechoose" v-model="item.AllScore" size="mini" controls-position="right" disabled></el-input-number>
                </div>
              </li>
            </ul>
            </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="suijidialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRandomQuestion">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import FillInTheBlanks from "components/Homework_bank/FillInTheBlanks_bank.vue";
import Multiselect from "components/Homework_bank/Multiselect_bank.vue";
import TrueFalse from "components/Homework_bank/TrueFalse_bank.vue";
import ShortAnswer from "components/Homework_bank/ShortAnswer_bank.vue";
import QuestionList from "components/Homework_bank/QuestionList_bank.vue";
import Synthesis from "components/Homework_bank/Synthesis_bank.vue";
export default Vue.extend({
  name: "paper-onnline",
  components: {
    Synthesis,
    // ChangeType,
    TrueFalse,
    ShortAnswer,
    QuestionList,
    Multiselect,
    FillInTheBlanks
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    paperId: {
      type: String,
      default: ""
    },
    paperType: {
      type: String,
      default: "Paper"
    },
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    },
    faceTeachStata: {
      default: ""
    }
  },
  data() {
    return {
      praname: "",
      totalscore: 0,
      suijitotalscore:0,
      condition: "未开始",
      changeCondition: "开始",
      diffcult: 1,
      dialogVisible: false,
      watch: false,
      del: false,
      number: 5,
      questionList: [],
      questionInfo: {},
      checkedIds: [],
      checkTotalScore: 0,
      exitIds: [],
      type: ["", "单选题", "多选题", "判断题", "填空题", "简答题", "综合题"],
      deleteId: "",
      AnswerPublishRule: 0,
      ScorePublichRule: 0,
      MultiselectRule: 0,
      FillRule: 0,
      quesSortRule: 0,
      seleteSortRule: 0,
      IsTest: false,
      childQuestionList: [],
      routerUrl: "",
      //showshow: false,
      isclear: 0,
      // 用于修改题目标题
      isShowInput: false,
      // 题目数量
      QuestionCount: 0,
      tisi: "确认删除该题目？",
      setScodeVisible: false,
      setBatchQuestionData: [],
      wholeSocre: 0,
      // 随机题
      suijidialogVisible:false,
      randomType: '1',
      Knowledges: [],
      difficultys: [],
      // 知识点列表
      knowledgeLists:[],
      randomQuesData:[],
      isDelete:false
    };
  },
  computed: {
    slected() {
      return `已选${this.checkedIds.length + this.exitIds.length}道题`;
    }
  },
  created() {
    this.getQuestionList();
    this.getKnowledgeList();
  },
  watch: {
    dialogVisible: function() {
      if (this.dialogVisible == false) {
        this.isclear = 1;
      }
    },
    setBatchQuestionData: {
      handler: function(val) {
        let totalScore = 0;
        for (let i = 0; i < val.length; i++) {
          this.setBatchQuestionData[i].totalScore =
            Number(val[i].totalNum) * Number(val[i].value);
          totalScore += Number(val[i].totalNum) * Number(val[i].value);
        }
        this.wholeSocre = totalScore;
        if (this.wholeSocre > 300) {
          this.$message({
            message: "总分不得大于300",
            type: "warning"
          });
          return false;
        }
      },
      deep: true
    }
  },
  methods: {
    // 随机出题生成试卷
    saveRandomQuestion(){
      var that = this;
      if (this.suijitotalscore <= 300) {
        this.$http.post("/api/XOrg/BookMaterial/saveRandomQuestion",{
          courseId: this.courseId,
          paperId: this.paperId,
          dataJson: JSON.stringify(this.randomQuesData),
          difficultys: this.difficultys,
          KnowledgeIds: this.Knowledges,
          lssueType: Number(this.randomType)
        }).then(function(rst) {
        if (rst.code > 0) {
          that.$message.warning(rst.msg);
          that.suijidialogVisible = false;
          that.getQuestionList();
        } else {
          that.$message.warning(rst.msg);
        }
      });
      } else {
        this.$message.error("总分不能超过300分");
      }
    },
    // 计算分数
    setRandomQuesScore(index){
      this.randomQuesData[index].QuestionCount = this.randomQuesData[index].QuestionCount ==''|| this.randomQuesData[index].QuestionCount==undefined ? 0:this.randomQuesData[index].QuestionCount;
      this.randomQuesData[index].QuestionScore = this.randomQuesData[index].QuestionScore == '' || this.randomQuesData[index].QuestionScore==undefined ? 0:this.randomQuesData[index].QuestionScore;
      this.randomQuesData[index].AllScore = this.randomQuesData[index].QuestionCount * this.randomQuesData[index].QuestionScore;
      var totalscoreNum = 0;
      this.randomQuesData.forEach(ele => {
        totalscoreNum += ele.AllScore;
      });
      this.suijitotalscore = totalscoreNum;
    },
    // 设置题目数量
    setQuesNumber(){
      this.getQuesNumber();
      this.randomQuesData.forEach(ele=>{
        ele.QuestionCount = 0;
        ele.AllScore = 0;
      });
      this.setRandomQuesScore(1);
    },
    // 获取题目数量
    getQuesNumber(){
      var that = this;
       this.$http.post("/api/XOrg/BookMaterial/getQuesNumber",{
         courseId: this.courseId,
         difficultys: this.difficultys,
         KnowledgeIds: this.Knowledges,
         Istest:this.IsTest
       }).then(function(rst) {
        if (rst.code > 0) {
          // that.setDefaultRandomQuesData();
          rst.questionNumbers.forEach((ele,index)=>{
            that.randomQuesData[index].QuestionAllCount = ele.count;
          });
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    // 随机题设置题目数
    setSuiJiQuesNumber(){
      this.getKnowledgeList();
      this.randomQuesData.forEach(ele=>{
        ele.QuestionCount = 0;
        ele.AllScore = 0;
      });
      this.setRandomQuesScore(1);
    },
    getKnowledgeList: function() {
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/getknowledgeList",{
          courseId: this.courseId,
          difficultys: this.difficultys,
          IsTest:this.IsTest
       }).then(function(rst) {
        if (rst.code > 0) {
          that.knowledgeLists = rst.knowledgeList;
          // that.setRandomByknowledge();
          var arr = that.randomQuesData;
          arr.forEach(ele=> {
            var info = rst.knowledgeList.find(
              p => p.Id == ele.KnowledgeId
            );
            ele.QuestionAllCount = info != undefined? info.questionCount:0;
          });
          that.randomQuesData = arr;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    // 设置随机题按题型规则默认数据
    setDefaultRandomQuesData(){ 
      var arr = [];
      var j = this.IsTest ? 4:6;
      for(var i = 1;i <= j;i++){
        arr.push({
          QuestionCount:0,
          KnowledgeName:'',
          KnowledgeId:'',
          QuestionAllCount:0,
          QestionType:i,
          QuestionScore:0,
          AllScore:0
        });
      }
      this.suijitotalscore = 0;
      this.randomQuesData = arr;
    },
    // 设置随机题按题型规则数据
    setRandomQuesData(data){
      var arr = [];
      var j = this.IsTest ? 4:6;
      for(var i = 0;i < j;i++){
        arr.push({
          QuestionCount:data.length>i?data[i].QuestionCount:0,
          KnowledgeName:'',
          KnowledgeId:'',
          QuestionAllCount:0,
          QestionType:i+1,
          QuestionScore: data.length>i?data[i].QuestionScore:0,
          AllScore:data.length>i?data[i].AllScore:0
        });
      }

      this.Knowledges = data.length==0|| data[0].KnowledgeIds=='' || data[0].KnowledgeIds== undefined ? []:data[0].KnowledgeIds.split("；");
      this.difficultys = data.length==0||data[0].Difficultys=='' || data[0].Difficultys== undefined ? []:data[0].Difficultys.split("；");
      this.randomQuesData = arr;
      this.setRandomQuesScore(1);
      this.getQuesNumber();
    },
    // 设置随机题按知识点规则默认数据
    setRandomByknowledge(){
      var arr = [];
      this.knowledgeLists.forEach(ele => {
         arr.push({
          QuestionCount:0,
          QestionType:0,
          QuestionAllCount: ele.questionCount,
          KnowledgeName:ele.KnowledgeName,
          KnowledgeId:ele.Id,
          QuestionScore:0,
          AllScore:0
        });
      });
      this.suijitotalscore = 0;
      this.randomQuesData = arr;
    },
     // 设置随机题按知识点规则数据
    setRandomQuesDataByknowledge(data){
      var arr = [];
      this.knowledgeLists.forEach(ele => {
        var info = data.find(
          p => p.KnowledgeId == ele.Id
        );
        arr.push({
          QuestionCount:info == undefined?0:info.QuestionCount,
          QestionType:0,
          QuestionAllCount: ele.questionCount,
          KnowledgeName:ele.KnowledgeName,
          KnowledgeId:ele.Id,
          QuestionScore:info == undefined?0:info.QuestionScore,
          AllScore:info == undefined?0:info.AllScore
        });
      });
      this.difficultys = data.length==0||data[0].Difficultys=='' || data[0].Difficultys== undefined ? []:data[0].Difficultys.split("；");
      this.randomQuesData = arr;
      this.setRandomQuesScore(1);
      this.getKnowledgeList();
    },
    // 初始化批量打分数组
    setBatchScoreData(questionList,ScoreRule) {
      let scoreData = [];
      var ScoreRuleList = ScoreRule ? JSON.parse(ScoreRule): [];
      let showScoreList = [];

      for(var i = 1; i <= 6; i++){
        let quesList = questionList.filter(item => {
          return item.QuestionType == i;
        });
        let scoreRule = ScoreRuleList.find(item => {
          return item.QuestionType == i;
        });
        let avgScore = scoreRule ? scoreRule.Score:0;
        scoreData.push({
          name: this.type[i],
          questionType: i,
          value: quesList.length > 0 ? avgScore : '',
          totalNum: quesList.length,
          totalScore: ''
        });
      }

      scoreData.forEach(item => {
        if (item.totalNum > 0) {
          showScoreList.push(item);
        } else {
          return false;
        }
      });

      this.setBatchQuestionData = showScoreList;
    },
    suijihandleClose(val){
      this.suijidialogVisible = false;
    },
    handleClose(done){
       this.cancelSetScore();
    },
    setBatchQuestionScore() {
      this.setScodeVisible = true;
    },
    cancelSetScore() {
      this.setScodeVisible = false;
    },
    sureSetScore() {
      if (this.wholeSocre > 300) {
        this.$message({
          message: "总分不得大于300",
          type: "warning"
        });
        return false;
      } else {
        var postBatchScore = [];
        this.setBatchQuestionData.forEach((item, index, arr) => {
          postBatchScore.push({
            QuestionType: arr[index].questionType,
            Score: Number(arr[index].value)
          });
        });
        this.$http
          .post("/api/XOrg/BookMaterial/setQuestionScore", {
            paperId: this.paperId,
            dataJson: JSON.stringify(postBatchScore)
          })
          .then(res => {
            if (res.code > 0) {
              this.$message.success(res.msg);
              // this.setBatchQuestionData = [];
              this.getQuestionList();
              this.setScodeVisible = false;
            }else{
              this.$message.warning(res.msg);
            }
          });
      }
    },
    updatePaperName: function() {
      if (this.praname == "") {
        this.$message.warning("名称不能为空！");
      } else {
        this.$http.post('/api/XOrg/BookMaterial/updatePaperName',{
          paperId: this.paperId, 
          paperName: this.praname, 
        }).then(rst => {
          if (rst.code > 0) {
            this.$message.success(rst.msg);
          } else {
            this.$message.warning(rst.msg);
          }
        });
      }
    },
    showTitleInput: function() {
      this.isShowInput = true;
    },
    hideTitleInput: function() {
      this.isShowInput = false;
      this.updatePaperName();
    },
    //返回上一级
    backone: function() {
      this.$router.go(-1);
    },
    // stretch() {
    //   this.show = !this.show;
    // },
    /*获取题库列表*/
    getQuestionList: function() {
      this.$http.post('/api/XOrg/BookMaterial/getPaperQuestionList',{
        courseId: this.courseId,
        paperId: this.paperId
      }).then( rst => {
        this.questionList = rst.list;
        this.setBatchScoreData(this.questionList,rst.rule.ScoreRule);
        this.IsTest = rst.IsTest;
        this.praname = rst.paperName;
        this.totalscore = rst.totalscore;
        this.exitIds = [];
        this.QuestionCount = rst.QuestionCount;
        rst.list.forEach(element => {
          this.exitIds.push(element.QuestionId);
        });

        this.AnswerPublishRule = rst.rule.AnswerPublishRule;
        this.ScorePublichRule = rst.rule.ScorePublichRule;
        this.MultiselectRule = rst.rule.MultiselectRule;
        this.FillRule = rst.rule.FillRule;
        this.quesSortRule = rst.rule.QuestionDisorderRule;
        this.seleteSortRule = rst.rule.SelectDisorderRule;
        this.isDelete = rst.isDelete;
        this.randomType = rst.rule.lssueType;
        // 随机出题渲染数据
        if(rst.rule.lssueType == 1){
          this.setRandomQuesData(rst.paperstructList);
        }else if(rst.rule.lssueType == 2){
          this.setRandomQuesDataByknowledge(rst.paperstructList);
        }else{
          this.setDefaultRandomQuesData();
          this.getQuesNumber();
          this.randomType = '1';
        }
      })
    },
    getQuestionInfoById: function() {
      this.$http.post('/api/XOrg/BookMaterial/getQuestionInfoById',{
        questionId: this.courseId
      }).then(rst => {
        this.questionInfo = rst.info;
      });
    },
    //获取题目类型
    getQuestionType(QuestionType) {
      if (QuestionType == 1) {
        return "单选题";
      } else if (QuestionType == 2) {
        return "多选题";
      } else if (QuestionType == 3) {
        return "判断题";
      } else if (QuestionType == 4) {
        return "填空题";
      } else if (QuestionType == 5) {
        return "简答题";
      } else {
        return "综合题";
      }
    },
    //难度显示
    changedif(dif) {
      if (dif == 1) {
        return "简单";
      } else if (dif == 2) {
        return "一般";
      } else {
        return "较难";
      }
    },
    /*保存试卷规则*/
    saveRule: function() {
      this.$http.post('/api/XOrg/BookMaterial/savePaperRule',{
        paperId: this.paperId, 
        answerPublishRule: this.AnswerPublishRule, 
        scorePublichRule: this.ScorePublichRule, 
        multiselectRule: this.MultiselectRule, 
        fillRule: this.FillRule, 
        quesSortRule: this.quesSortRule, 
        seleteSortRule: this.seleteSortRule
      }).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },
    //上移题目
    moveUp: function(index) {
      let questionId1 = this.questionList[index].Id;
      let questionId2 = this.questionList[index - 1].Id;
      this.$http.post('/api/XOrg/BookMaterial/changeQuestionIndex',{
        paperId: this.paperId,
        questionId1: questionId1,
        questionId2: questionId2
      }).then( rst => {});
      //
      this.getQuestionList();
    },
    //下移题目
    moveDown: function(index) {
      let questionId1 = this.questionList[index].Id;
      let questionId2 = this.questionList[index + 1].Id;
      this.$http.post('/api/XOrg/BookMaterial/changeQuestionIndex',{
        paperId: this.paperId,
        questionId1: questionId1,
        questionId2: questionId2
      }).then( rst => {});
      this.getQuestionList();
    },

    // 删除题目
    setDeleteId: function(question) {
      if (this.QuestionCount == 1) {
        this.tisi =
          "这已经是最后一题了，如果删除，该作业也将被强制删除，是否确定？";
      } else {
        this.tisi = "确认删除该题目？";
      }
      this.deleteId = question.Id;
      this.del = true;
    },
    // 取消删除
    cancleDelete: function() {
      this.deleteId = "";
      this.del = false;
    },
    // 删除题目
    delQuestionInfoById: function(index) {
      let ids = [];
      ids.push(this.deleteId);
      this.$http.post('/api/XOrg/BookMaterial/deletePaperQuestionById',{
        ids: ids,
        paperId: this.paperId
      }).then(rst => {
        this.del = false;
        if (rst.code > 0) {
          this.getQuestionList();
          this.$message({ type: "success", message: rst.msg });
        } else {
          this.$message({ type: "warning", message: rst.msg });
        }
      });
    },
    setQuestionScore: function(questionId, score) {
      this.$http.post('/api/XOrg/BookMaterial/setQuestionScoreById',{
        questionId: questionId,
        score: score
      }).then(rst => {
        if (rst.code > 0) {
          this.getQuestionList();
          this.$message({ type: "success", message: rst.msg });
        } else {
          this.$message({ type: "warning", message: rst.msg });
        }
      });
    },
    //弹窗的取消
    onDialogCancle() {
      this.dialogVisible = false;
      this.checkedIds = [];
      this.checkTotalScore = 0;
      this.isclear = 1;
    },
    //弹窗的确定
    onDialogSure() {
      this.addQuestionInfo();
    },
    //添加题目
    addQuestionInfo: function() {
      if (this.checkedIds.length >= 0) {
        if (this.checkTotalScore + Number(this.totalscore) <= 300) {
          this.$http.post('/api/XOrg/BookMaterial/addPaperQuestion',{
            ids: this.checkedIds,
            paperId: this.paperId
          }).then(rst => {
            if (rst.code > 0) {
              this.getQuestionList();
              this.checkedIds = [];
              this.checkTotalScore = 0;
              this.isclear = 1;
              this.dialogVisible = false;
              // this.setScodeVisible = true;
              this.$message.success("题目添加成功，请设置题目分数");
            }
          });
        } else {
          this.$message.error("总分不能超过300分");
        }
      }
    },
    goto: function(name, params) {
      if (name === "lectures") {
        this.$router.push({
          name: name,
          params: {
            courseId: this.courseId,
            classId: this.classId,
            faceId: this.faceId,
            classType: this.faceTeachStata
          }
        });
      } else {
        this.$router.push({ name: name, params: params });
      }
    },
    blurQuestion: function(
      id,
      score,
      QuestionType,
      subCount
    ) {
      var that = this;
      var isSet = 1;
      if (QuestionType == 6) {
        if (!this.IsExcept(score, subCount)) {
          this.$message.warning("请设置可以平均赋值给子题目的分数");
          isSet = 0;
        }
      }
      if (isSet == 1) {
        if (score > 0 && score <= 100) {
          var totalScore = 0;
          that.questionList.forEach(ele => {
            totalScore += Number(ele.Score);
          });
          if (totalScore <= 300) {
            this.$http.post('/api/XOrg/BookMaterial/setQuestionScoreById',{
              questionId: id,
              score: score
            }).then(rst => {
              if (rst.code < 0) {
                this.$message.warning(rst.msg);
              }
              this.getQuestionList();
            });
          } else {
            this.$message.error("总分不能超过300分");
            this.getQuestionList();
          }
        } else {
          this.$message.error("请输入1~100的分数");
        }
      }
    },
    IsExcept: function(m, n) {
      m = parseInt(m.toString().replace(".", ""));
      n = parseInt(n.toString().replace(".", ""));
      while (m % 2 == 0 && m != 0) m = m / 2;
      while (m % 5 == 0 && m != 0) m = m / 5;
      while (n % 2 == 0 && n != 0) n = n / 2;
      while (n % 5 == 0 && n != 0) n = n / 5;

      if (n == 0) return false;
      if (n == 1 || m == 0) return true;
      return m % n == 0;
    },
    // 点击显示自动出卷
    showAutoPaper: function() {
      this.suijidialogVisible = true;
    },
    randomTypeChange(tab, event){
      this.difficultys = [];
      if(tab.name == '1'){
        this.setDefaultRandomQuesData();
        this.getQuesNumber();
      }else if(tab.name == '2'){
        this.setRandomByknowledge();
        this.getKnowledgeList();
      }
    }
  }
});
</script>

<style lang="scss">
// .yk-homework {
//   padding-bottom: 50px;
//   .yk-home-work-name {
//     float: left;
//     padding-top: 10px;
//     font-size: 18px;
//     color: #fff;
//   }
//   .yk-home-work-score {
//     float: left;
//     padding-left: 30px;
//     padding-top: 10px;
//     font-size: 18px;
//     color: #fff;
//   }

//   .yk-comeback-s-new {
//     border-bottom: 1px solid #596880;
//     background: #fff;
//     padding: 20px 39px;
//     .yk-ap-que-name {
//       float: left;
//       font-size: 18px;
//       color: #000;
//       width: 500px;
//     }
//     .yk-ap-que-btn-back {
//       float: right;
//     }
//     .gobackBtn-brainStorm {
//       position: fixed;
//       right: 53px;
//       top: 10px;
//       z-index: 2000;
//       padding: 2px 10px;
//       .wl-icon-fanhui2 {
//         font-size: 29px;
//       }
//     }
//     .hander-paper{
//       float: right;
//       font-size: 14px;
//     }
//     .active{
//       border: 1px dashed #ffffff;
//     }
//     .auto-paper{
//       float: right;
//       font-size: 14px;
//     }
//   }
//   .yk-comeback:after {
//     content: "";
//     height: "";
//     clear: both;
//     display: block;
//     visibility: hidden;
//   }
//   .affix {
//     border-bottom: 1px solid #596880;
//     background: #374256;
//   }
//   .get-quetion-list-wrapper {
//     color: #fff;
//     border: 1px dashed #fff;
//     border-radius: 10px;
//     padding: 10px 0;
//     text-align: center;
//     margin: 0 40px;
//     .wl-icon-tianjia {
//       margin-right: 10px;
//       font-size: 25px;
//       border-radius: 50%;
//       border: 1px solid #fff;
//       vertical-align: -2px;
//     }
//     span {
//       font-size: 18px;
//     }
//   }
//   .comeback {
//     text-decoration: none;
//     font-size: 18px;
//     color: #fff;
//     line-height: 80px;
//     float: left;
//     margin-left: 30px;
//   }
//   .yk-batch-set-score-con {
//     padding: 20px 40px 0;
//     text-align: right;
//   }
//   .yk-s-workset {
//     padding: 0 40px;
//     margin: 30px auto;
//     margin-top: 20px;
//     border-radius: 10px;
//     box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
//     ul {
//       width: 100%;
//       list-style: none;
//       margin: 0;
//       padding: 0;
//       color: #fff;
//       border-radius: 10px;
//       overflow: hidden;
//       li {
//         height: 50px;
//         width: 100%;
//         line-height: 50px;
//         padding: 0 30px;
//         box-sizing: border-box;
//         &:nth-child(even) {
//           background: #415474;
//         }
//         &:nth-child(odd) {
//           background: #3c4c66;
//         }
//         .yk-setTitle {
//           display: inline-block;
//           width: 20%;
//         }
//         .el-radio {
//           width: 19%;
//           // margin-left: 5%;
//           color: #fff;
//         }
//         i {
//           line-height: 50px;
//         }
//         .saveSet {
//           line-height: 1px;
//           height: 30px;
//           margin-top: 10px;
//           font-size: 16px;
//         }
//       }
//       .yk-setCount{
//         color: #409EFF;
//         margin-left: 5%;
//         font-size: 14px;
//       }
//       .yk-setScore{
//         color: #409EFF;
//         margin-left: 8%;
//         font-size: 14px;
//       }
//       .topicRulechoose{
//         width: 100px;
//         height: 28px;
//         margin-right: 6%;
//         input{
//           width: 52px;
//           text-align: left;
//           padding: 0;
//           margin-top: 1px;
//           margin-left: 20px;
//           height: 26px;
//           border-radius: 0%;
//           font-size: 15px;
//         }
//         i{
//           line-height: 14px;
//         }
//       }
//     }
//   }
//   .yk-s-homework-questions {
//     padding: 0 40px;
//     margin: 0 auto;
//     margin-top: 70px;
//     .yk-hw-question {
//       list-style: none;
//       margin: 0;
//       padding: 0;
//       li {
//         position: relative;
//         margin-bottom: 30px;
//         border-radius: 10px;
//         color: #fff;
//         background: #3f5880;
//         .yk-question-container {
//           //   overflow: hidden;
//           height: 100%;
//           width: 100%;
//         }
//         header {
//           height: 50px;
//           width: 100%;
//           line-height: 50px;
//           padding: 0 16px;
//           border-bottom: 1px solid #4c6080;
//           font-size: 18px;
//           .delete {
//             color: #fff;
//             margin-top: 12px;
//             background: #cc224e;
//             border-color: #cc224e;
//             padding: 7px 10px;
//             margin-left: 12px;
//           }
//           .yk-diffcult {
//             margin-left: 30px;
//           }
//           .el-input__inner {
//             height: 30px;
//             border: none;
//           }
//           .yk-sequence {
//             margin-top: 13px;
//             line-height: 22px;
//             margin-right: 5px;
//             height: 20px;
//             font-size: 16px;
//             width: 20px;
//             border-radius: 50%;
//             background: #fff;
//             text-align: center;
//             float: left;
//             color: #666;
//           }
//         }
//         .all-question {
//           padding: 0 40px;
//           font-size: 18px;
//           .timu,
//           .yk-analysis {
//             margin: 20px 0;
//             span {
//               float: left;
//             }
//             .content,
//             p {
//               margin: 0;
//               padding: 0;
//               padding-left: 3em;
//             }
//             .p {
//               padding-left: 3em;
//               margin: 20px 0;
//             }
//           }
//         }
//         .open-analysis {
//           position: absolute;
//           bottom: -38px;
//           left: 50%;
//           margin-left: -120px;
//           width: 240px;
//           font-size: 18px;
//           height: 40px;
//           border-radius: 0 0 40px 40px;
//           line-height: 40px;
//           text-align: center;
//           background: rgba(63, 88, 128, 0.58);
//         }
//       }
//     }
//   }
//   .yk-random-tab{
//     padding: 20px;
//     border: 1px solid #E4E7ED;
//     border-top: none;
//     position: relative;
//     font-size: 16px;
//     .yk-text-count{
//       position: absolute;
//       top: 32px;
//       right: 70px;
//     }
//     li{
//       line-height: 50px;
//       font-size: 16px;
//         .el-input{
//         line-height: 40px;
//         height: 40px;
//       }
//       .el-input--mini .el-input__inner{
//         line-height: 40px;
//         height: 40px;
//       }
//     }
//     .yk-number-text{
//       float: left;
//       // width: 410px;
//     }
//     .yk-setScore{
//       font-size: 16px;
//       display: inline-block;
//       width: 60px;   
//       // margin-right: 60px;
//     }
//     .el-input-number.is-controls-right[class*=mini] [class*=decrease], .el-input-number.is-controls-right[class*=mini] [class*=increase]{
//       line-height: 19px;
//     }
//     .yk-setTitle-text{
//       width: 160px;
//       display: inline-block;
//       overflow: hidden;
//       text-overflow: ellipsis;
//       white-space: nowrap;
//       line-height: 14px;
//     }
//   }
//   .yk-s-homework-questions:first-child {
//     margin-top: 30px;
//   }
//   .bounce-enter-active {
//     animation: bounce-in 0.5s;
//   }
//   .bounce-leave-active {
//     animation: bounce-in 0.5s reverse;
//   }
//   @keyframes bounce-in {
//     0% {
//       transform: scale(0);
//     }
//     50% {
//       transform: scale(1.5);
//     }
//     100% {
//       transform: scale(1);
//     }
//   }
// }
.flr .el-input .el-input__inner {
  background: #fff;
  color: #000;
  font-size: 15px;
}
// 批量设置打分
.yk-set-question-batch-score-main {
  //  margin:20px 30px;
  .set-score-head {
    padding: 0 20px;
    text-align: right;
    font-size: 16px;
    color: #3fa2ff;
    font-weight: bold;
    height: 39px;
    line-height: 39px;
    background: #e9eff5;
    .sp-total-score {
      color: #333333;
    }
  }
  .set-score-list-li {
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    border: 1px solid #e9eff5;
    .sp-question-name {
      margin-right: 20px;
    }
    .sp-all-score-1 {
      margin-left: 10px;
    }
    .total-score-con {
      float: right;
    }
    .sp-all-score {
      color: #333333;
    }
  }
}

  .yk-homework {
    padding-bottom: 50px;
    color:#333;
    .yk-home-work-name {
      float: left;
      padding-top: 10px;
      font-size: 18px;
      // color: #fff;
    }
    .yk-home-work-score {
      float: left;
      padding-left: 30px;
      padding-top: 10px;
      font-size: 18px;
      color: #000;
    }

    .yk-comeback-s-new {
      border-bottom: 1px solid #596880;
      width: 100%;
      background: #ffffff;
      padding: 20px 39px;
      box-sizing: border-box;
      .yk-ap-que-name {
        float: left;
        font-size: 18px;
        color: #000;
        width: 500px;
      }
      .yk-ap-que-btn-back {
        float: right;
      }
      .gobackBtn-brainStorm {
        float: right;
        margin-left: 15px;
        padding: 2px 10px;
        .wl-icon-fanhui2 {
          font-size: 29px;
        }
      }
      .hander-paper{
        float: right;
        font-size: 14px;
      }
    }
    .yk-comeback:after {
      content: "";
      height: "";
      clear: both;
      display: block;
      visibility: hidden;
    }
    .affix {
      border-bottom: 1px solid #596880;
      background: #374256;
    }
    .get-quetion-list-wrapper {
      color: #000;
      border: 1px dashed #000;
      border-radius: 10px;
      padding: 10px 0;
      text-align: center;
      margin: 0 40px;
      .wl-icon-tianjia1 {
        margin-right: 10px;
        font-size: 25px;
        border-radius: 50%;
        border: 1px solid #000;
        vertical-align: -2px;
      }
      span {
        font-size: 18px;
      }
    }
    .comeback {
      text-decoration: none;
      font-size: 18px;
      // color: #fff;
      line-height: 80px;
      float: left;
      margin-left: 30px;
    }
    .yk-batch-set-score-con {
      padding: 20px 40px 0;
      text-align: right;
    }
    .yk-s-workset {
      padding: 10px 40px 10px 40px;
      margin: 30px;
      margin-top: 20px;
      border-radius: 10px;
      box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
      background: #fff;
      ul {
        width: 100%;
        list-style: none;
        margin: 0;
        padding: 0;
        // color: #fff;
        border-radius: 10px;
        overflow: hidden;
        li {
          height: 50px;
          width: 100%;
          line-height: 50px;
          padding: 0 30px;
          box-sizing: border-box;
          color: #333;
          &:nth-child(even) {
            // background: #415474;
          }
          &:nth-child(odd) {
            // background: #3c4c66;
          }
          .yk-setTitle {
            display: inline-block;
            width: 20%;
          }
          .el-radio {
            width: 20%;
            color: #000;
          }
          i {
            line-height: 50px;
          }
          .saveSet {
            line-height: 1px;
            height: 30px;
            margin-top: 10px;
            font-size: 16px;
          }
        }
        li:nth-child(odd){
          background: #e9eff5;
        }
        li:nth-child(even){
          background: #FAFAFA;
        }
      }
    }
    .yk-s-homework-questions {
      padding: 0 40px;
      margin: 0 auto;
      margin-top: 70px;
      .yk-hw-question {
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          position: relative;
          margin-bottom: 30px;
          border-radius: 10px;
          color: #333;
          background: #fff;
          .yk-question-container {
            //   overflow: hidden;
            height: 100%;
            width: 100%;
          }
          .el-form-item__label{
              color:#333;
          }
          .el-input.is-disabled .el-input__inner{
                background-color: #edf2f6;
                border-color: #edf2f6;
                color: #333;
                cursor: not-allowed;
          }
          .yk-table-dark.el-table td{
            background-color: #f5f5f5;
            color: #333;
          }
          .yk-table-dark{
            border-radius: 0;
          }
          header {
            height: 50px;
            width: 100%;
            line-height: 50px;
            padding: 0 16px;
            border-bottom: 1px solid #4c6080;
            font-size: 18px;
            box-sizing: border-box;
            .delete {
              // color: #fff;
              margin-top: 12px;
              background: #cc224e;
              border-color: #cc224e;
              padding: 7px 10px;
              margin-left: 12px;
            }
            .yk-diffcult {
              margin-left: 30px;
            }
            .el-input__inner {
              height: 30px;
              border: none;
            }
            .yk-sequence {
              margin-top: 13px;
              line-height: 22px;
              margin-right: 5px;
              height: 20px;
              font-size: 16px;
              width: 20px;
              border-radius: 50%;
              background: #409EFF;
              text-align: center;
              float: left;
              color: #fff;
            }
          }
          .all-question {
            padding: 0 40px;
            font-size: 18px;
            .timu,
            .yk-analysis {
              margin: 20px 0;
              span {
                float: left;
              }
              .content,
              p {
                margin: 0;
                padding: 0;
                padding-left: 3em;
              }
              .p {
                padding-left: 3em;
                margin: 20px 0;
              }
            }
          }
          .open-analysis {
            position: absolute;
            bottom: -38px;
            left: 50%;
            margin-left: -120px;
            width: 240px;
            font-size: 18px;
            height: 40px;
            border-radius: 0 0 40px 40px;
            line-height: 40px;
            text-align: center;
            background: rgba(63, 88, 128, 0.58);
          }
        }
      }
    }
    .yk-s-homework-questions:first-child {
      margin-top: 30px;
    }
    .bounce-enter-active {
      animation: bounce-in 0.5s;
    }
    .bounce-leave-active {
      animation: bounce-in 0.5s reverse;
    }
    @keyframes bounce-in {
      0% {
        transform: scale(0);
      }
      50% {
        transform: scale(1.5);
      }
      100% {
        transform: scale(1);
      }
    }
    .flr .el-input .el-input__inner {
      background: #e7ecf4;
      color: #333;
      font-size: 15px;
    }
    .el-form-item__content,
    .el-form-item__label{
      color:#333 !important;
    }
    .yk-home-tf--wrapper .yk-mm-up-down-wrapper,
    .yk-home-shor-answer-wrapper .yk-mm-up-down-wrapper,
    .yk-home-fill-wrapper .yk-mm-up-down-wrapper,
    .yk-home-syn-que-wrapper .yk-mm-up-down-wrapper{
      background:unset;
    }
    .el-input__inner{
      border-radius: 0;
    }
  }
  .yk-home-mul-wrapper{
    .yk-mm-up-down-wrapper{
      background-color:#edf2f6;
    }
  } 


</style>
